











































































































































































































































































































































































































































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'
import TaskApi from '@/api/task'
import AreaApi from '@/api/area'
import { checkCarNo, debounce } from '@/utils/util'
import addTaskMixin from './addTaskMixin'
import { FIRST_VISIT } from '@/utils/const'

let id: any = 0

const debounceSearch = debounce(300)

@Component({
	components: {
		VNodes: {
			functional: true,
			render: (h: any, ctx: any) => ctx.props.vnodes,
		},
	},
})
export default class RelationsOrders extends Mixins(addTaskMixin) {
	public taskType: any = FIRST_VISIT
	private get orderTypeList() {
		const list = this.$store.state.setting.orderTypeList || []
		return list.map((item: any) => {
			return {
				label: item.value,
				value: item.key,
			}
		})
	}
}
